import PageHero from "../components/sections/PageHero";
import ProjectShowcase from "../components/sections/ProjectShowcase";
import CTASection from "../components/sections/CTASection";
import { Link } from "react-router-dom";

export default function Projects() {
  return (
    <>
      <PageHero
        eyebrow="Project Showcase"
        title="Selected work,"
        italic="one frame at a time."
        subtitle="Real Urban Painter projects across epoxy flooring, waterproofing and painting — filter by service to see the type of work most relevant to your requirement."
        image="https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/f8ktji6j_Screenshot%202026-08-16%20092114.png"
      />

      {/* Intro content block — improves text-to-code ratio */}
      <section
        data-testid="projects-intro"
        className="py-16 md:py-24 bg-white"
      >
        <div className="max-w-4xl mx-auto px-5 md:px-8 space-y-5 text-ink-mid leading-relaxed text-base md:text-lg">
          <p>
            Every photograph below is a real Urban Painter project. Our epoxy
            flooring portfolio covers industrial factories, warehouses,
            production lines, showrooms and clean rooms across Bangalore,
            Hyderabad, Kolkata, Pune, Chennai, Baddi, Ahmedabad and Gurgaon —
            wherever the volume, timeline and specification requires a
            specialist team.
          </p>
          <p>
            Our waterproofing portfolio focuses on Gurugram, Manesar, Sohna and
            the wider Delhi NCR — rooftops, terraces, bathrooms, basements,
            balconies, metal roofs and exterior walls. Painting projects
            (interior, exterior, commercial and industrial) are captured as
            they are handed over.
          </p>
          <p className="text-ink-muted">
            To see a specific type of work, use the filter chips below (Epoxy
            Flooring · Waterproofing · Painting). If you have a similar
            project, WhatsApp us a photograph of your site — we&rsquo;ll come
            back with an inspection date and a preliminary recommendation.
          </p>
          <div className="flex flex-wrap gap-3 pt-2">
            <Link
              to="/contact?service=inspection"
              className="inline-flex items-center gap-2 bg-ink hover:bg-ink-soft text-white px-6 py-3 text-[11px] tracking-[0.25em] uppercase"
            >
              Book a site inspection
            </Link>
            <Link
              to="/epoxy-flooring"
              className="inline-flex items-center gap-2 border border-ink hover:bg-ink hover:text-white text-ink px-6 py-3 text-[11px] tracking-[0.25em] uppercase transition-colors"
            >
              Epoxy — Pan India
            </Link>
          </div>
        </div>
      </section>

      <ProjectShowcase />
      <CTASection />
    </>
  );
}
